import { IonButton, IonButtons, IonContent, IonIcon, IonPage, IonToolbar, withIonLifeCycle } from "@ionic/react";
import { arrowBackSharp, arrowForwardSharp } from "ionicons/icons";
import moment from "moment";
import React from "react";
import AcrofitHeader from "../components/AcrofitHeader";
import db from "../components/Database";
import { syncAlimentos } from "../components/Funciones";
import TablaCalorias from "../components/TablaCalorias";
import IDatosIniciales from "../interfaces/IDatosIniciales";

const dias = [
    {nombre:"Domingo",codigo:"D"},
    {nombre:"Lunes",codigo:"L"},
    {nombre:"Martes",codigo:"M"},
    {nombre:"Miercoles",codigo:"X"},
    {nombre:"Jueves",codigo:"J"},
    {nombre:"Viernes",codigo:"V"},
    {nombre:"Sábado",codigo:"S"}
]

class PlanPage extends React.Component{

    tablas = [] as Array<TablaCalorias|null>

    state = {
        semanas:0 as number,
        total_semanas:0 as number,
        semana:0 as number,
        datos_iniciales:{} as IDatosIniciales
    }

    async ionViewDidEnter(){
        this.init()
        syncAlimentos()
    }

    init = async () => {
        const datos_iniciales = await db.datos_iniciales.toArray()
        const semanas = moment().diff(moment(datos_iniciales[0].fecha_registro).startOf('week'),"weeks")
        const total_semanas = Math.abs(parseFloat(datos_iniciales[0].peso)-parseFloat(datos_iniciales[0].peso_objetivo))/parseFloat(datos_iniciales[0].kilos_semanales)
        await this.setState({semana:semanas>total_semanas?total_semanas:semanas,semanas,total_semanas,datos_iniciales:datos_iniciales[0]})
        this.tablas.forEach(tabla => {
            tabla?.update()
        })
    }
  
    nextWeek = () =>{
      const {semana,total_semanas} = this.state
      if(semana<total_semanas){
        this.setState({semana:semana+1})
      }
    }
  
    lastWeek = () =>{
      const {semana} = this.state
      if(semana>0){
        this.setState({semana:semana-1})
      }
    }
  
    thisWeek = () =>{
      this.init()
    }

    render(){
        const {semana,semanas,total_semanas,datos_iniciales} = this.state
        return (
            <IonPage>
                <AcrofitHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton disabled={semana<=0} fill="solid" color={semana==semanas?"tertiary":"medium"} onClick={this.lastWeek}><IonIcon icon={arrowBackSharp} /></IonButton>
                        </IonButtons>
                        <IonButtons slot="end">
                            <IonButton disabled={semana>=total_semanas} fill="solid" color={semana==semanas?"tertiary":"medium"} onClick={this.nextWeek}><IonIcon icon={arrowForwardSharp} /></IonButton>
                        </IonButtons>
                        <IonButton expand="full" style={{textAlign:"center"}} color={semana==semanas?"tertiary":"medium"} onClick={this.thisWeek}>Semana {semana+1}/{total_semanas+1}</IonButton>
                    </IonToolbar>
                </AcrofitHeader>
                <IonContent className="no-bg">
                {
                    dias.map((dia,k) => (
                        moment().startOf('week').add(semana-semanas,"weeks").add(k,'days').isSameOrAfter(moment(datos_iniciales.fecha_registro).format("YYYY-MM-DD")) && (
                            <TablaCalorias 
                                ref={c => this.tablas.push(c)} 
                                color={moment().startOf('week').add(semana-semanas,"weeks").add(k,'days').dayOfYear() === moment().dayOfYear() ? "tertiary" : undefined} 
                                key={semana+"-"+k} 
                                title={dia.nombre+" "+moment().startOf('week').add(semana-semanas,"weeks").add(k,'days').format("DD/MMM")} 
                                fecha={moment().startOf('week').add(semana-semanas,"weeks").add(k,'days').format()} />
                        )
                    ))
                }
                </IonContent>
            </IonPage>
        )
    }
}

export default withIonLifeCycle(PlanPage)